import './FiSelectMaterialFillingDialog.scss';
import * as angular from 'angular';
import { Component } from '../Component';
import { FiFurnitureService } from './../fiFurniture/FiFurnitureService';


@Component({
    controllerAs: 'vm',
    template: require('./FiSelectMaterialFillingDialog.html'),
    bindings: {
        //
    },
})
export class FiSelectMaterialFillingDialog {
    static $inject = [
        '$mdDialog',
        'fiFurnitureService',
        '$http',
    ];

    constructor(
        private $mdDialog: angular.material.IDialogService,
        private fs: FiFurnitureService,
        private $http: angular.IHttpService,
    ) {
        //
    }

    filling_items = [];
    filling_results = [];

    filter = {
        fillings: {
            style: 0,
            filling_count: 0,
        }
    };

    $onInit() {
        // Fillings
        this.$http.get('https://www.fitit.lt/db/fillings.php').then((data) => {
            this.filling_items.push(data.data);
            this.filling_results = this.filling_items[0];
        });
    }

    close() {
        this.$mdDialog.cancel();
    }

    applyFilter(f) {
       
            this.filling_results = this.filling_items[0];

            if (this.filter.fillings.style) {
                this.filling_results = this.filling_results.filter(item => item.style == this.filter.fillings.style );
            }

            if (this.filter.fillings.filling_count) {
                this.filling_results = this.filling_results.filter(item => item.filling_count == this.filter.fillings.filling_count );
            }

       
    }

}